import jQuery from 'jquery';

const { UI } = Mobi2Go;
const { Locations } = Mobi2Go;

UI.View({
    name: 'headoffice_header',
    model: 'Order',
    el: '[data-view="headoffice-header"]',
    template: jQuery('[data-template="headoffice-header"]').html(),
    initialise() {
        this.render();
        Locations.onReady(this.render);
    },
    render() {
        // Do not render the header for certain embeds
        const c_app = Mobi2Go.app.getContainerApp();
        if (
            c_app !== 'loke' &&
            c_app !== 'iseeinternational' &&
            c_app !== 'steer73'
        ) {
            const html = this.template(Mobi2Go);
            this.$el.html(html);
        }
    },
    model_listeners: {},
    DOM_listeners: {
        'click [href="#About"]': function() {
            UI.helpers.scrollTo('#About', null, true);

            return false;
        },
        'click [href="#Menu"]': function() {
            UI.helpers.scrollTo('#Menu', null, true, -25);

            return false;
        },
        'click [href="#Locations"]': function() {
            UI.helpers.scrollTo('#Locations', null, true);

            return false;
        },
    },
});
